import { Amplify } from "aws-amplify";
import { initializeCompetitionPrivateSession } from "./competitionPrivateSession";

const authConfig = {
  aws_region: process.env.REACT_APP_COGNITO_REGION || "us-east-2",
  user_pool_id: process.env.REACT_APP_COGNITO_USER_POOL_ID || "us-east-2_gY4zXnJ4H",
  user_pool_client_id:
    process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID || "1b2l2c85ml4cubevgb6u3otfat",
  identity_pool_id:
    process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID || "us-east-2:b7fe77aa-48e8-4334-805c-ef59212c359a",
  oauth: {
    domain:
      process.env.REACT_APP_COGNITO_DOMAIN ||
      "43179c257d2fe3012d59.auth.us-east-2.amazoncognito.com",
    scopes: ["phone", "email", "openid", "profile", "aws.cognito.signin.user.admin"],
    redirect_sign_in_uri: [
      process.env.REACT_APP_COGNITO_REDIRECT_SIGN_IN || "http://localhost:3000/profile"
    ],
    redirect_sign_out_uri: [
      process.env.REACT_APP_COGNITO_REDIRECT_SIGN_OUT || "http://localhost:3000/"
    ],
    response_type: "code"
  }
};

let configured = false;

export function configureAmplifyAuth() {
  if (configured) {
    return;
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: authConfig.user_pool_id,
        userPoolClientId: authConfig.user_pool_client_id,
        identityPoolId: authConfig.identity_pool_id,
        loginWith: {
          email: true,
          oauth: {
            domain: authConfig.oauth.domain,
            scopes: authConfig.oauth.scopes,
            redirectSignIn: authConfig.oauth.redirect_sign_in_uri,
            redirectSignOut: authConfig.oauth.redirect_sign_out_uri,
            responseType: authConfig.oauth.response_type
          }
        }
      }
    }
  });

  configured = true;
  initializeCompetitionPrivateSession();
}
